
import {  defineComponent, onMounted, ref } from 'vue';
import DocumentCard from '@/components/DocumentCard.vue';
import { IQuiz } from '@/types/quiz';
import { routeContractorsItem, routeContractorsUserItem } from '@/core/constants';
import { useRoute, useRouter } from 'vue-router';
import { CtaType } from '@/types/CtaType';

export default defineComponent({
  name: 'ContractorCompanyPeople',
  components: {
    DocumentCard
  },
  setup() {
    const documents = ref<IQuiz[]>([]);
    const router = useRouter();
    const route = useRoute();
    const {
      params: { id },
    } = route;

    onMounted(() => {
      const payload = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
      documents.value = payload.map(id => ({
        id: id,
        name: `Contractor ${id}`,
        color: 1,
        cta_type: CtaType.EPX,
        answers_progress: `${Math.floor(Math.random() * 100) + 1}`,
        created_at: new Date(),
        updated_at: new Date(),
        archived_at: null,
        filter_values: [],
        is_update_pending: false,
        validation_errors: []
      }));
    });



    const businessFunctionId = ref(-1);

    const goToQuizEdit = (quizId: number) => { //@todo should be refactored
      router.push({
        name: routeContractorsUserItem,
        params: {
          id: id,
          userId: quizId
        }
      });
    };

    return {
      id,
      documents,
      goToQuizEdit,
      businessFunctionId,
    };
  },
});
